import { render, staticRenderFns } from "./costcalc.vue?vue&type=template&id=05004fc7"
import script from "./costcalc.vue?vue&type=script&lang=js"
export * from "./costcalc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports